<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<h1 class="Poem-title" id="_idParaDest-6" lang="en-GB"><a id="_idTextAnchor007"></a>Between life and death</h1>
<p class="Verse-first" lang="en-GB">There is life in you, find who you must</p>
<p class="Verse-main" lang="en-GB">There is life in you, make profitable choices</p>
<p class="Verse-main" lang="en-GB">The ones that will shape the course of your destiny</p>
<p class="Verse-main" lang="en-GB">You are standing between life and death</p>
<p class="Verse-main" lang="en-GB">Do it now, the choice is for now</p>
<p class="Verse-main" lang="en-GB">A day will come that will be too late</p>
<p class="Verse-main" lang="en-GB">Life evaporates just like a vapour</p>
<p class="Verse-main" lang="en-GB">Becomes a moment when death comes</p>
<p class="Verse-main" lang="en-GB">Death comes without a warning without preferences</p>
<p class="Verse-main" lang="en-GB">Death makes life quite small</p>
<p class="Verse-main" lang="en-GB">Both big and small will see it </p>
<p class="Verse-main" lang="en-GB">Everyone will taste the unpleasant substance</p>
<p class="Verse-main" lang="en-GB">Death is cruel, knows no sympathy, has no friends</p>
<p class="Verse-main" lang="en-GB">The time and hour are when least expected</p>
<p class="Verse-main" lang="en-GB">The consequence physical absence</p>
<p class="Verse-main" lang="en-GB">Life is here so is death </p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781398406179_EPUB8.vue?ec1099ae